import { RouteObject } from 'react-router';

const kontaktRoutes: RouteObject[] = [
  {
    path: 'kontakt',
    lazy: () => import('./page/kontakt-page.tsx'),
  },
];

export default kontaktRoutes;
